var map = {
	"./DetalhesProduto.tsx": [
		2477,
		19,
		453,
		864,
		477
	],
	"./HomePage.tsx": [
		256,
		318,
		917,
		256
	],
	"./PaginaCatalogos.tsx": [
		9286,
		19,
		286
	],
	"./PaginaProdutos.tsx": [
		7079,
		19,
		318,
		79
	],
	"./PaginaVideos.tsx": [
		2012,
		19,
		318,
		453,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7963;
module.exports = webpackAsyncContext;